import { Autocomplete, Grid, InputAdornment, TextField } from "@mui/material";
import withRole from "../../Hooks/withRole";
import { CollectPaymentFormProps } from "../../Utils/Types";
//import style from "../../Styles/collectPaymentForm.module.css";
import { Vocabulary } from "../../Utils/Vocabulary";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { TransactionValidationSchema } from "../../Utils/Models";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import { NumericFormatCustom } from "../../Utils/NumericFormatComponents";
import { onFormError } from "../../Utils/Utils";
import { endpoints } from "../../Utils/UrlEnum";
import { postData } from "../../Services/postData";
import { FormsIds, PaymentMethods, PaymentType } from "../../Utils/Constants";
import { useParams } from "react-router-dom";
import useCustomMemo from "../../Hooks/useCustomMemo";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { getData } from "../../Services/getData";

function CollectPaymentForm(props: CollectPaymentFormProps) {
  const { id } = useParams(); //orderId
  const userId = localStorage.getItem("userId");
  const { control, handleSubmit } = useForm({
    resolver: yupResolver(TransactionValidationSchema),
    mode: "onChange",
    reValidateMode: "onChange",
    context: undefined,
    shouldFocusError: true,
    shouldUnregister: false,
    criteriaMode: "firstError",
  });
  const {
    setTriggerReload,
    collectPaymentType,
    workPoint,
    clientId,
    onClose,
    maxAmount,
  } = props;
  const memo = useCustomMemo();
  const bankAccounts = memo?.storage.bankAccounts;
  const workPoints = memo?.storage?.workPoints || [];
  const [loading, setLoading] = useState(false);
  const [userWorkPoint, setUserWorkPoint] = useState<any>(null);

  // Fetch user data to get workPoint if not provided via props
  useEffect(() => {
    if (!workPoint && userId) {
      const fetchUserWorkPoint = async () => {
        const url = `${endpoints.user.main}/${userId}`;
        const res = (await getData(url)) as any;
        if (res?.data?.workpoint_id) {
          const foundWorkPoint = workPoints.find(
            (wp: any) => wp._id === res.data?.workpoint_id?._id
          );
          setUserWorkPoint(foundWorkPoint);
        }
      };
      fetchUserWorkPoint();
    }
  }, [workPoint, userId, workPoints]);

  const onSubmit = async (data: any) => {
    if (loading) return; // Prevent multiple clicks

    //check if amount is greater than maxAmount
    if (maxAmount !== undefined && data.amount > maxAmount) {
      toast.error(Vocabulary.amountExceedsRemaining);
      return;
    }

    setLoading(true); // Disable button

    //set the current order id and user id the current logged in user
    data.orderId = id;
    data.userId = null;
    data.paymentType = PaymentType.INCOME;
    data.createdByUserId = userId;
    data.clientId = clientId;

    //find account based on workPoint name (use userWorkPoint if workPoint prop not provided)
    const effectiveWorkPoint = workPoint || userWorkPoint;
    const account = bankAccounts.find(
      (acc: any) => acc.name === effectiveWorkPoint?.name
    );
    data.accountId = account?._id;

    const url = `${endpoints.payments.main}`;
    const res = (await postData(url, data)) as any;
    if (!res || res?.error) {
      return; // Keep modal open on error
    }
    setTriggerReload(true);
    if (onClose) {
      onClose(); // Close modal on success
    }
    setLoading(false); // Re-enable button
  };

  const renderPaymentMethods = () => {
    if (typeof collectPaymentType === "object") {
      return (
        <Grid item xs={12} md={12} lg={12}>
          <Controller
            name={`paymentMethod`}
            control={control}
            defaultValue={PaymentMethods.CASH}
            render={({ field: { ref, ...field }, fieldState: { error } }) => (
              <Autocomplete
                value={field.value || undefined}
                freeSolo={false}
                disablePortal
                disableClearable
                clearOnBlur={true}
                options={collectPaymentType}
                isOptionEqualToValue={(option: any, value: any) => {
                  return option === value;
                }}
                getOptionLabel={(option: any) =>
                  option?.management || option || ""
                }
                onChange={(_event, value: any) => {
                  field.onChange(value);
                }}
                renderInput={(params) => (
                  <TextField
                    value={field?.value || " "}
                    error={!!error}
                    helperText={error?.message}
                    label={Vocabulary.paymentMethod}
                    {...params}
                    variant="outlined"
                  />
                )}
              />
            )}
          />
        </Grid>
      );
    }
  };
  /**
   *
   */
  return (
    <div>
      <form
        id={FormsIds.collectPayment}
        onSubmit={handleSubmit(onSubmit, onFormError)}
      >
        <Grid container spacing={3}>
          {renderPaymentMethods()}
          <Grid item xs={12} md={12} lg={12}>
            <Controller
              name={"amount"}
              control={control}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <TextField
                  {...field}
                  name="amount"
                  id="amount"
                  type="text"
                  label={Vocabulary.amountReceived}
                  fullWidth
                  error={!!error}
                  helperText={error?.message}
                  InputProps={{
                    inputComponent: NumericFormatCustom,
                    startAdornment: (
                      <InputAdornment position="start">
                        <LocalAtmIcon />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        {Vocabulary.currency}
                      </InputAdornment>
                    ),
                  }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={12} lg={12}>
            <Controller
              name={"description"}
              control={control}
              render={({ field: { ref, ...field }, fieldState: { error } }) => (
                <TextField
                  {...field}
                  name="description"
                  id="description"
                  label={Vocabulary.description}
                  fullWidth
                  multiline
                  rows={4}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          </Grid>
        </Grid>
      </form>
    </div>
  );
}

export default withRole(CollectPaymentForm);
